// services/carWashApi.ts
import api from "../../../../../features/auth/axiosConfig";
import { Order, CarDetailState } from "../../types";

// ✅ Fetch customer order by ID
export const fetchOrderData = async (id: string): Promise<Order> => {
  const response = await api.get(`/app/v1/pos/shopping_cart/${id}`);
  if (!response.data?.result) {
    throw new Error("Unexpected response structure.");
  }
  return response.data.result[0];
};

// ✅ Fetch all active categories
export const fetchCategories = async (): Promise<CarDetailState[]> => {
  const response = await api.get(`/app/v1/pos/category?is_deleted=False`);
  return response.data.category_details || [];
};

// ✅ Confirm order
export const confirmOrder = async (orderData: any) => {
  const response = await api.post(`/app/v1/pos/order`, orderData);
  return response.data;
};

// ✅ Update customer by ID
export const updateCustomer = async (id: string, customerData: any) => {
  await api.patch(`/app/v1/pos/customer/${id}`, customerData);
};
